import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientReportsPage from "@/pages/client/ClientReportsPage";

export const Route = createFileRoute("/client/reports")({
  head: () => pageHead("Client · Reports", "AKIVA client · reports portal.", "/client/reports", true),
  component: ClientReportsPage,
});
